import Vue from 'vue'
import Router from 'vue-router'
import Main from './views/Main.vue'
import Test from './views/Test.vue'
import Table from './views/Table.vue'

Vue.use(Router)

const router = new Router({
    //mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            redirect: "/main"
        },
        {
            path: '/main',
            name: 'main',
            component: Main
        },
        {
            path: '/test',
            name: 'test',
            component: Test
        },
        {
            path: '/table',
            name: 'table',
            component: Table
        },
    ]
})

/**
 * まず実行される部分
 */
router.beforeEach((to, from, next) => {
    next();
});

export default router
